'use client';

import { useState } from 'react';
import { InfoIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { MarketClockState } from '@/lib/client/use-market';
import { holidayInfo } from '@/lib/market-clock';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/** "Holiday ⓘ": the details (the holiday, when the market opens, the session on screen) in a
 * tooltip that opens on hover, focus or a tap (phones have no hover). */
export function HolidayTag({ clock, session, label = 'Holiday', className, iconOnly }: {
  clock: MarketClockState; session?: string | null; label?: string; className?: string; iconOnly?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const info = holidayInfo(clock, new Date(), session);
  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild>
        <button type="button" aria-label={`${label}: ${info}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((o) => !o); }}
          className={cn('inline-flex items-center gap-1 whitespace-nowrap', className)}>
          {!iconOnly && <span>{label}</span>}
          <InfoIcon className="size-3.5 shrink-0 opacity-70" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-64 text-[12px] leading-snug">{info}</TooltipContent>
    </Tooltip>
  );
}
